import React, { useState } from "react";
import { Route, Routes } from "react-router";
import tmsRouteMap from "../constants/tms-route.map";
import TmsPosAccommodation from "../views/pos/tms-pos-pages/tms-pos-accommodation";
import TmsPosDarshanam from "../views/pos/tms-pos-pages/tms-pos-darshanam";
import TmsPosDonation from "../views/pos/tms-pos-pages/tms-pos-donation";
import TmsPosPettyDonation from "../views/pos/tms-pos-pages/pos-petty-donation";

import TmsPosKalayanakatta from "../views/pos/tms-pos-pages/tms-pos-kalayanakatta";
import TmsPosPrasadam from "../views/pos/tms-pos-pages/tms-pos-prasadam";
import TmsPosPratyakshaSeva from "../views/pos/tms-pos-pages/tms-pos-pratyaksha-seva";
import TmsPosProducts from "../views/pos/tms-pos-pages/tms-pos-products";
import TmsPosThulabharam from "../views/pos/tms-pos-pages/tms-pos-thulabharam";
import TmsPosTollgate from "../views/pos/tms-pos-pages/tms-pos-tollgate";
import { withRouter } from "../utils/tms-with-router/tms-with-router";
import TmsPosHome from "../views/pos/tms-pos-pages/tms-pos-home";
import TmsPosPerformanceScan from "../views/pos/tms-pos-pages/tms-pos-performance-scan";
import TmsPosPrasadamScan from "../views/pos/tms-pos-pages/tms-pos-prasdam-scan";
import TmsPosCheckInScan from "../views/pos/tms-pos-pages/tms-pos-check-in-scan";
import TmsPosTicketDetails from "../views/pos/tms-pos-pages/tms-pos-ticket-details";
import TmsPosAccommodationRooms from "../views/pos/tms-pos-pages/tms-pos-accommodation-rooms";
import TmsPosAccommodationScan from "../views/pos/tms-pos-pages/tms-pos-accommodation-scan";
import TmsPosAccommodationDashboard from "../views/pos/tms-pos-pages/tms-pos-accommodation-dashbaord";
import TmsPosManualEntry from "../views/pos/tms-pos-pages/tms-pos-manual-entry";
import TmsPosPreassignedCheckin from "../views/pos/tms-pos-pages/tms-pos-preassigned-checkin";
import TmsPosMisc from "../views/pos/tms-pos-pages/tms-pos-misc";
import TmsPosEntryScan from "../views/pos/tms-pos-pages/tms-pos-entry-scan";
import TmsPosRentsAndLeases from "../views/pos/tms-pos-pages/tms-pos-rents-and-lease";
import TmsPosProtocol from "../views/pos/tms-pos-pages/tms-pos-protocol/tms-pos-protocol";
import TmsPosProtocolDashboard from "../views/pos/tms-pos-pages/tms-pos-protocol/tms-pos-protocol-dashboard";
import TmsPosProtocolPrint from "../views/pos/tms-pos-pages/tms-pos-protocol/tms-pos-protocol-print";
import TmsPosBus from "../views/pos/tms-pos-pages/tms-pos-bus";
import TmsPosPublication from "../views/pos/tms-pos-pages/tms-pos-publication";
// import checkPermissions from "../utils/tms-permissions/tms-permissions";
// import TmsPosMap from "../constants/tms-pos.map";
// import { BaseContext } from "../contexts/BaseContext";
import PosAnnadanam from "../views/pos/tms-pos-pages/pos-annadanam";
import PosWalkinScan from "../views/pos/tms-pos-pages/pos-walkin-scan";
import PosChildrenWalkinScan from "../views/pos/tms-pos-pages/pos-children-walkin-scan";
import CheckPointScan from "../views/pos/tms-pos-pages/checkpoint-scan";
import PosVehiclePass from "../views/pos/tms-pos-pages/pos-vehicle-pass";
import PosVehiclePassScan from "../views/pos/tms-pos-pages/pos-vehicle-scan";
import PosShivaDeeksha from "../views/pos/tms-pos-pages/pos-shiva-deeksha";
import PosShivaDeekshaScan from "../views/pos/tms-pos-pages/pos-shiva-deeksha-scan";
import PosChildrenTagScan from "../views/pos/tms-pos-pages/pos-children-tag-scan";
import DutyPassAssign from "../views/pos/tms-pos-pages/duty-pass-assign";
import PagaPassAssign from "../views/pos/tms-pos-pages/paga-pass-assign";
import EmployeePassAssign from "../views/pos/tms-pos-pages/employee-pass-assign";
import PagaPassScan from "../views/pos/tms-pos-pages/paga-pass-scan";
import DutyPassScan from "../views/pos/tms-pos-pages/duty-pass-scan";
import EmployeePassScan from "../views/pos/tms-pos-pages/employee-pass-scan";
const TmsPosRoutes = ({ router }) => {
  // const { userDetails } = useContext(BaseContext);
  const [widthFlag, setWidthFlag] = useState(false);

  // const templeDetails = JSON.parse(localStorage.getItem("templeDetails"));
  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      {/* {router.location.pathname !== "/pos" && (
        <div
          style={{
            width: "17%",
            minWidth: "158px",
            maxWidth: "230px",
            padding: "0px 20px 10px 0px",
          }}
        >
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            {" "}
            {TmsPosMap
              // .filter((item) => {
              //   if (item.hidden !== "") {
              //     return templeDetails?.configuration[item.hidden];
              //   } else {
              //     return true;
              //   }
              // })
              .map((card, i) => {
                return checkPermissions(userDetails, card) ? (
                  <li
                    key={"key" + i}
                    style={{
                      backgroundColor:
                        router.location.pathname === card.route
                          ? "#1890ff"
                          : "white",
                      color:
                        router.location.pathname === card.route
                          ? "white"
                          : "black",
                      // border: `1px solid ${card.textColor}`,
                      cursor: "pointer",
                      padding: "10px",
                      textAlign: "left",
                    }}
                    onClick={() => router.navigate(card.route)}
                  >
                    {" "}
                    {card.title}
                  </li>
                ) : (
                  ""
                );
              })}
          </ul>
        </div>
      )} */}
      <div
        style={{ width: "100%" }}
        // style={{ width: widthFlag ? "100%" : "83%" }}
      >
        <Routes>
          <Route
            exact
            path={tmsRouteMap.pos_accommodation.replace("/pos", "")}
            element={<TmsPosAccommodation />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_accommodation_dashboard.replace("/pos", "")}
            element={<TmsPosAccommodationDashboard />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_accommodation_rooms.replace("/pos", "")}
            element={<TmsPosAccommodationRooms />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_acc_scan.replace("/pos", "")}
            element={<TmsPosAccommodationScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_darshanam.replace("/pos", "")}
            element={<TmsPosDarshanam />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_annadanam.replace("/pos", "")}
            element={<PosAnnadanam />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_donation.replace("/pos", "")}
            element={<TmsPosDonation />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_petty_donation.replace("/pos", "")}
            element={<TmsPosPettyDonation />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_kalayanakatta.replace("/pos", "")}
            element={<TmsPosKalayanakatta />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_prasadam.replace("/pos", "")}
            element={<TmsPosPrasadam />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_shiva_deeksha.replace("/pos", "")}
            element={<PosShivaDeeksha />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_shiva_deeksha_scan.replace("/pos", "")}
            element={<PosShivaDeekshaScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_sevas.replace("/pos", "")}
            element={<TmsPosPratyakshaSeva />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_products.replace("/pos", "")}
            element={<TmsPosProducts />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_thulabharam.replace("/pos", "")}
            element={<TmsPosThulabharam />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_tollgate.replace("/pos", "")}
            element={<TmsPosTollgate />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_performance_sccanner.replace("/pos", "")}
            element={<TmsPosPerformanceScan />}
          />{" "}
          <Route
            exact
            path={tmsRouteMap.pos_prasadm_scanner.replace("/pos", "")}
            element={<TmsPosPrasadamScan />}
          />{" "}
          <Route
            exact
            path={tmsRouteMap.pos_check_in_scan.replace("/pos", "")}
            element={<TmsPosCheckInScan />}
          />{" "}
          <Route
            exact
            path={tmsRouteMap.pos_checkpoint_scan.replace("/pos", "")}
            element={<CheckPointScan />}
          />{" "}
          <Route
            exact
            path={tmsRouteMap.pos_pre_assigned_check_in_scan.replace(
              "/pos",
              ""
            )}
            element={<TmsPosPreassignedCheckin />}
          />{" "}
          <Route
            exact
            path={tmsRouteMap.pos_ticket_details.replace("/pos", "")}
            element={<TmsPosTicketDetails />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_manual_entry.replace("/pos", "")}
            element={<TmsPosManualEntry />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_misc.replace("/pos", "")}
            element={<TmsPosMisc />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_entryScan.replace("/pos", "")}
            element={<TmsPosEntryScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_walker_scan.replace("/pos", "")}
            element={<PosWalkinScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_childern_walker_scan.replace("/pos", "")}
            element={<PosChildrenWalkinScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_childeren_tag_scan.replace("/pos", "")}
            element={<PosChildrenTagScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_protocol.replace("/pos", "")}
            element={<TmsPosProtocol />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_protocol_dashboard.replace("/pos", "")}
            element={<TmsPosProtocolDashboard />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_protocol_print.replace("/pos", "")}
            element={<TmsPosProtocolPrint />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_rents_and_leases.replace("/pos", "")}
            element={<TmsPosRentsAndLeases />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_bus.replace("/pos", "")}
            element={<TmsPosBus />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_publication.replace("/pos", "")}
            element={<TmsPosPublication />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_vehicle_pass.replace("/pos", "")}
            element={<PosVehiclePass />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_vehicle_pass_scan.replace("/pos", "")}
            element={<PosVehiclePassScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_paga_pass_assign.replace("/pos", "")}
            element={<PagaPassAssign />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_duty_pass_assign.replace("/pos", "")}
            element={<DutyPassAssign />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_employee_pass_assign.replace("/pos", "")}
            element={<EmployeePassAssign />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_paga_pass_scan.replace("/pos", "")}
            element={<PagaPassScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_duty_pass_scan.replace("/pos", "")}
            element={<DutyPassScan />}
          />
          <Route
            exact
            path={tmsRouteMap.pos_employee_pass_scan.replace("/pos", "")}
            element={<EmployeePassScan />}
          />
          <Route
            path={"/"}
            element={<TmsPosHome setWidthFlag={setWidthFlag} />}
          />
        </Routes>
      </div>
    </div>
  );
};
export default withRouter(TmsPosRoutes);
